import { SectionList } from "../blocks/registry";
import { loadPage, pageMeta } from "../lib/page";
import { loadSectionData } from "../lib/section-data";
import { EmptyState } from "../components/Skeletons";
import type { Route } from "./+types/home";

/**
 * The homepage.
 *
 * Every section — hero, trust indicators, key services, why choose VEO, how VEO
 * works, featured insights, consultation CTA and the closing disclaimer — is a
 * CMS section rendered through the block registry. Nothing on this page is
 * written in this file, which is what lets an editor reorder or replace any of
 * it without a deploy.
 */
export async function loader({ request }: Route.LoaderArgs) {
  const preview = new URL(request.url).searchParams.get("preview");
  const page = await loadPage("/", preview);

  // Services and articles are fetched here rather than inside the blocks, so
  // they are in the server-rendered HTML a crawler reads.
  return { page, sectionData: await loadSectionData(page.sections) };
}

export function meta({ loaderData, matches }: Route.MetaArgs) {
  return pageMeta(loaderData?.page, { fallbackTitle: "Home", matches });
}

export default function Home({ loaderData }: Route.ComponentProps) {
  const { page, sectionData } = loaderData;

  return (
    <main id="main">
      {page.sections.length > 0 ? (
        <SectionList sections={page.sections} data={sectionData} />
      ) : (
        <div className="container-site section-y">
          <EmptyState
            title="This page has no content yet"
            description="Sections added in the CMS will appear here."
          />
        </div>
      )}
    </main>
  );
}
